import { logger } from './logger';

/**
 * 알림 딥링크가 창을 열 때 그 창의 쿼리를 무효화하는 **주입 슬롯**.
 *
 * ## 왜 슬롯인가 (맵을 여기 두지 않고)
 *
 * 무효화 맵은 `entities/*` 와 `features/*`(club · room-reservation · off-day-work)의 키
 * 팩토리를 모두 참조해야 한다. 그런데 딥링크 진입은 세 곳이고 레이어가 제각각이다 —
 * `pages/MainPage`(알림 패널 클릭) · `shared/lib/onboarding`(푸시 URL) ·
 * `features/onboarding`(온보딩 완료 후 재생). 뒤 둘은 FSD 상 그 팩토리들을 볼 수 없다.
 *
 * 그래서 정본을 볼 수 있는 유일한 레이어인 **app 이 맵을 들고 여기에 주입**한다.
 * `widgets/CarouselDock` 의 `registerViewComponentPreloaders` 와 같은 형태다.
 *
 * ## 등록 전 호출은 no-op 이다
 *
 * 무효화는 신선도 보정이지 착지 조건이 아니다 — 주입 전이거나 맵이 던져도 창은 열려야 한다.
 *
 * `view` 가 `AppView` 가 아니라 `string` 인 것도 의도다 — 푸시 URL 경로의 `DeepLink.view`
 * (`@aegislab/shared` 의 `parseDeepLinkFromQuery`)는 검증되지 않은 쿼리 문자열이다.
 * 모르는 값은 맵이 no-op 으로 흘린다.
 */
export type DeepLinkInvalidator = (view: string) => void;

let invalidator: DeepLinkInvalidator | null = null;

/** 앱 초기화(app/providers)가 한 번 호출한다. `null` 은 테스트 초기화용. */
export function registerDeepLinkInvalidator(next: DeepLinkInvalidator | null): void {
  invalidator = next;
}

/** 딥링크가 연 창의 좌표를 무효화한다. 등록 전이면 조용히 아무것도 하지 않는다. */
export function invalidateDeepLinkQueries(view: string): void {
  if (!invalidator) return;
  try {
    invalidator(view);
  } catch (error) {
    // 무효화 실패로 착지를 막지 않는다 — 최악이라도 예전 동작(옛 화면)으로 돌아갈 뿐이다.
    logger.warn('[deepLink] 쿼리 무효화 실패 — 착지는 그대로 진행합니다.', error);
  }
}
